import React from 'react'
import Form from 'react-bootstrap/Form'

interface Option {
  id: string
  name: string
}

interface Props {
  options: Option[]
  onChange: (id: string) => void
  label: string
}

const CheckboxSelect: React.FC<Props> = ({ options, onChange, label }) => {
  return (
    <div>
      <Form.Group className="my-3">
        <Form.Label className="IDText mb-0">
          {label}: <span style={{ color: 'red' }}>*</span>
        </Form.Label>
        <div
          style={{
            border: '#DCDCDC 1px solid',
            height: '100px',
            overflow: 'auto',
            padding: '10px',
            width: '100%',
          }}
        >
          {options.sort().map((option) => {
            return (
              <Form.Check
                required
                type={'checkbox'}
                label={option.name}
                onChange={() => onChange(option.id)}
                id={option.id}
                key={option.id}
              />
            )
          })}
        </div>
      </Form.Group>
    </div>
  )
}

export default CheckboxSelect
